module.exports = __webpack_public_path__ + "media/images/responsive/page_common/title_stripes-b41f8461e1223721f895eb59516e51d2.png";